import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getSkuConfigurationDataAsync } from 'src/services/shouldCostAIBased.services'

const initialState = {
  getConfigurationLoader: false,
  getConfigurationData: {
    l1: 'L1',
    l2: 'L2',
    l3: 'L3',
    primary_id: 'Primary Id',
    secondary_id: 'Secondary Id',
    isSecondaryIDVisible: false,
    sku_url: 'SKU URL',
    isSkuUrlVisible: false,
    comments: "Comments",
    isCommentsVisible: false
  },
  getConfigurationError: '',
}

export const configurationSlice = createSlice({
  name: 'get-config-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSkuConfigurationDataAsync.pending), (state) => {
      state.getConfigurationLoader = true
    })
    builder.addMatcher(isAnyOf(getSkuConfigurationDataAsync.fulfilled), (state, action) => {
      state.getConfigurationLoader = false

      // Transform the array of objects into the desired format
      const configData = action.payload.data?.reduce((acc, { key, value, is_visible }) => {
        acc[key] = { value, isVisible: is_visible }
        return acc
      }, {})

      state.getConfigurationData = {
        primary_id: configData.primary_id.value || initialState.getConfigurationData.primary_id,
        secondary_id: configData.secondary_id.value || initialState.getConfigurationData.secondary_id,
        l1: configData.l1.value || initialState.getConfigurationData.l1,
        l2: configData.l2.value || initialState.getConfigurationData.l2,
        l3: configData.l3.value || initialState.getConfigurationData.l3,
        isSecondaryIDVisible: configData.secondary_id?.isVisible ?? initialState.getConfigurationData.isSecondaryIDVisible,
        sku_url: configData.sku_url.value || initialState.getConfigurationData.sku_url,
        isSkuUrlVisible: configData.sku_url?.isVisible ?? initialState.getConfigurationData.isSkuUrlVisible,
        comments: configData.comments.value || initialState.getConfigurationData.comments,
        isCommentsVisible: configData.comments?.isVisible ?? initialState.getConfigurationData.isCommentsVisible,
      }
    })
    builder.addMatcher(isAnyOf(getSkuConfigurationDataAsync.rejected), (state, action) => {
      state.getConfigurationLoader = false
      state.getConfigurationError = action.payload.message
    })
  },
})

export default configurationSlice.reducer
